export default Object.freeze({
  /**
   * Breakpoints a.k.a. Mediaqueries
   *
   * @property {Object[]} mediaQueries
   * @property {name} mediaQueries[].size
   * @property {string} mediaQueries[].query
   * @property {number} mediaQueries[].min
   * @property {number} mediaQueries[].max
   * @property {number} mediaQueries[].colCount
   */
  mediaQueries: [
    {
      name: "MQ1",
      query: "(min-width: 0px) and (max-width: 479px)",
      min: 0,
      max: 319,
      colCount: 12,
    },
    {
      name: "MQ2",
      query: "(min-width: 480px) and (max-width: 767px)",
      min: 320,
      max: 767,
      colCount: 12,
    },
    {
      name: "MQ3",
      query: "(min-width: 768px) and (max-width: 991px)",
      min: 768,
      max: 991,
      colCount: 12,
    },
    {
      name: "MQ4",
      query: "(min-width: 992px) and (max-width: 1279px)",
      min: 992,
      max: 1279,
      colCount: 12,
    },
    {
      name: "MQ5",
      query: "(min-width: 1280px)",
      min: 1280,
      // fallBack for IE
      max: Number.MAX_SAFE_INTEGER || 10000,
      colCount: 12,
    },
  ],
});
